<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { isMobile } from '$lib/utils/isMobile';

    import LogosView from './Logos.View.svelte';

    import type { LogosContent } from '$lib/types/Components/Logos/LogosContent';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let id = '';
    export let content: LogosContent;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let layout = DEFAULT_LAYOUT;
</script>

<LogosView
    {id}
    box={content.box}
    images={content.images}
    isGrayscale={content.isGrayscale}
    size={content.size}
    {transitionDelay}
    {transitionEffect}
    {layout}
    isMobile={$isMobile}
/>
